<template>
  <v-main>
    <!-- <v-divider class="pb-2 mx-0 my-0" v-show="envio_digitacao_robo && (exibirNivelGuia || formData.tipo_consulta!='lotes')"></v-divider><br /> -->
    <v-form ref="edicaoRecursosFilterForm">
      <v-row class="pt-4 pl-2 pr-0">
        <v-col class="px-2 py-0" cols="1" v-if="!!parametrizacao && parametrizacao.RG_ANEXO_TISS">
          <label>Status</label>
          <v-select
            v-model="formData.status_envio"
            :items="comboEstados"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
          <template v-slot:item="data">
              <template v-if="(typeof data.item !=='object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
               <v-list-item-content>
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar size="14" :color="data.item.color" v-if="data.item.color">
                </v-list-item-avatar>
              </template>
            </template>
          </v-select>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Ident. na operadora</label> 
          <v-select
            v-model="formData.identificador_prestador"
            :items="identOperadoraList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Número do Lote</label>
          <v-autocomplete
            v-model="formData.recurso_lote_id"
            :items="numLotesList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Número da Guia</label>
          <v-autocomplete
            v-model="formData.recurso_guia_id"
            :items="numGuiasList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Código do procedimento</label>
          <v-autocomplete
            v-model="formData.codigo_procedimento"
            :items="procedimentosList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 pt-5 align-right" cols="3">
          <v-btn
            style="margin-right: 16px !important"
            small
            height="32px"
            color="primary"
            class="px-2 mr-2"
            depressed
            @click="filterList(formData)"
            >Filtrar</v-btn
          >
          <v-btn
            outlined
            small
            height="32px"
            color="primary"
            class="px-2 ml-0"
            depressed
            @click="clearFilter()"
            >Limpar Filtro</v-btn
          >
        </v-col>
        <v-spacer></v-spacer>
           <!--  v-if="tipo_consulta=='lote'" -->
          <v-btn class="mt-5" color="primary" text @click="downloadDocument()" v-show="formData.tipo_consulta == 'lotes'">
              <v-icon small class="pr-2">fa-download</v-icon>
              Exportar tabela 
          </v-btn>
      </v-row>
    </v-form>
    <ProtocoloEnvioRecursoDlg
      :close="()=>showProtocoloEnvioRecursoDlg=false"
      :dialog="showProtocoloEnvioRecursoDlg"
      :grupoEconomico="grupoEconomico"
      :info="dadosPagamento"
      :protocolo_pagamento="protocolo_pagamento"
      :updatePage="()=>filterList(formData)"
    />
  </v-main>
</template>

<script>
import { mapState } from "vuex";
import ProtocoloEnvioRecursoDlg from '@/components/recebiveis/acompanhamento_de_envio/ProtocoloDlg'
const initialFormData = {
  status_envio: null,
  identificador_prestador: null,
  recurso_lote_id: null,
  recurso_guia_id: null,
  codigo_procedimento: null
};
export default {
  components:{
    ProtocoloEnvioRecursoDlg
  },
  data() {
    return {
      comboEstados:[],
      formData: { },
      identOperadoraList: [],
      showProtocoloEnvioRecursoDlg: false,
      envio_digitacao_robo: null
    };
  },
  watch: {
    filterData: {
      deep: true,
      handler(val) {
       this.formData = {...val};
       this.$nextTick();
      },
    },
    ident_operadora:{
      deep: true,
      handler(val) {
        this.identOperadoraList = val.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
        this.identOperadoraList.unshift({ id: null,  descricao: "Selecione"})
      }
    },
    parametrizacao:{
      deep: true,
      handler() {
        let ind = this.comboEstados.findIndex(el => el.id == 4)
        if(this.parametrizacao.RG_ENVIORECURSO_DIGITACAO){
          this.envio_digitacao_robo = true
          if(ind == -1)
            this.comboEstados.splice(3, 0, { id: 4, descricao: 'Transmissão parcial', color: '#4A4A4A'});
        } else {
          this.envio_digitacao_robo = false
          this.formData.tipo_consulta = 'lotes'
          if(ind > -1)
            this.comboEstados.splice(ind, 1)
        }
      }
    }
  },
  mounted() {
    this.formData = Object.assign({}, this.initialFormData, this.filterData);
    this.identOperadoraList = this.ident_operadora.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
    this.identOperadoraList.unshift({ id: null,  descricao: "Selecione"})
    //let tipo_consulta = this.formData.tipo_consulta
    this.comboEstados = this.estadoList
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules : (state) => state.formRules,
    }),
  },
  methods: {
    downloadDocument() {
      let acao = "getcsvlotesrecursados";
      let Payload = {
        grupo_economico: this.grupoEconomico,
        pagamento_id: this.dadosPagamento.id,
        envioRoboDigi: this.parametrizacao.RG_ENVIORECURSO_DIGITACAO,
        ...this.filterData
      };
      this.$store
        .dispatch(
          "documents/getDocumentPost",
          { Payload, acao },
          { root: true }
        ).then(()=> {
          alert()
        })
    },
    clearFilter() {
      let tipo_consulta = this.formData.tipo_consulta
      this.formData = { ...initialFormData, tipo_consulta}
      this.filterList(this.formData)
    },
    selectList() {
      this.clearFilter();
    },
  },
  props: {
    dadosPagamento: Object,
    estadoList: Array,
    filterData: Object,
    filterList: Function,
    ident_operadora: Array,
    numGuiasList: Array,
    numLotesList: Array,
    parametrizacao: Object,
    procedimentosList: Array,
    protocolo_pagamento: Object,
  },
};
</script>